import { UtilitarioService } from "@app/services/utilitario.service";

export class RelatorioRequisicaoFinanceira
{
    Id: number;
    ProcessoId: number;
    NomeCliente: string;
    DataCriacao: string;
    DataAutuacao: string;
    DataPrevisaoRecebimento: string;
    Comarca: string;
    NumeroRequisicao: string;
    ValorRequerido: number;
    ValorBrutoEscritorio: number;
    ValorLiquidoEscritorio: number;
    Expedido: boolean;
}

export class FiltrosRequisicaoFinanceira
{
    Precatorio: boolean;
    RPV: boolean;
    TipoData: string;
    DataInicial: string;
    DataFinal: string;
    OrgaoJudiciarioId: number;
    Homologado: boolean;
    Autuado: boolean;
    Sucumbencia: boolean;
    Recebido: boolean;
    
    constructor(){
        this.TipoData = 'Lancamento';
        this.DataInicial = UtilitarioService.retornaPrimeiraDataMesAtualISO();
        this.DataFinal = UtilitarioService.retornaDataAtualMaisDiasISO(0);
    }
}